import React from "react";
import "./SectionTopOfTable.css";
import { useSelectorCustom } from "../abstruct-component/useSelectorCustom";
import { formatNumberWithCommas } from "../abstruct-component/FunctionRemoveCommas";
import { AbstructLang } from "../abstruct-component/AbstructLang";

function SectionTopOfTable({
  isSearch,
  expenses,
  displayArr,
  config,
  langLocal,
  title,
  titleBtn,
  FunctionBtn,
}) {
  const { currency } = useSelectorCustom();
  const { translate } = AbstructLang();

  const totalAmount = expenses?.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );
  const totalCount = expenses?.length || 0; // Calculate totalCount

  return (
    <div
      style={
        config
          ? {
              padding: "30px 0px 20px 0px",
            }
          : { padding: "30px 30px 20px 30px" }
      }
      className="div_top_table"
      dir={langLocal === "ar" ? "rtl" : "ltr"}
    >
      {isSearch ? (
        <div className="div-search-vcard">
          <h2 className="main_title_color">
            {title}
            {totalAmount && totalAmount > 0 && (
              <span
                style={{ color: "#ff5e5bef", fontSize: "15px" }}
                className={
                  langLocal === "ar" ? "margin_right_10" : "margin_left_10"
                }
              >
                ({" "}
                {`${formatNumberWithCommas(totalAmount)} ${translate(
                  currency
                )}`}{" "}
                )
              </span>
            )}
            {totalCount > 0 && (
              <span
                style={{
                  color: "#00aaff",
                  fontSize: "15px",
                  marginLeft: "10px",
                }}
              >
                ({`${totalCount} ${translate("items")}`})
              </span>
            )}
          </h2>
          <input placeholder="Search ..." />
        </div>
      ) : (
        <h2 className="main_title_color">
          {title}
          {totalAmount && totalAmount > 0 && (
            <span
              style={{ color: "#ff5e5bef", fontSize: "15px" }}
              className={
                langLocal === "ar" ? "margin_right_10" : "margin_left_10"
              }
            >
              ({" "}
              {`${formatNumberWithCommas(totalAmount)} ${translate(currency)}`}{" "}
              )
            </span>
          )}
          {totalCount > 0 && (
            <span
              style={{ color: "#1C5E91", fontSize: "15px", marginLeft: "10px" }}
              className={
                langLocal === "ar" ? "margin_right_10" : "margin_left_10"
              }
            >
              ({`${totalCount} ${translate("expenses")}`})
            </span>
          )}
        </h2>
      )}
      {titleBtn && (
        <button className="btn_top_table" onClick={FunctionBtn}>
          {titleBtn}
        </button>
      )}
    </div>
  );
}

export default SectionTopOfTable;
